export default __webpack_public_path__ + "static/media/Carousel-image-3.7be8e170.png";